module.exports = __webpack_public_path__ + "img/gondola.154ff3ad.png";